// test1360
(1360 && 0);
